import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
//import { FormsModule } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule, Http, RequestOptions } from '@angular/http';
//import { routing }        from './app.routing';
import { RouterModule, Routes } from '@angular/router';

import { APP_BASE_HREF} from '@angular/common';
//import { BaseRequestOptions } from '@angular/http';
// import { AUTH_PROVIDERS } from 'angular2-jwt';

import { AppComponent }  from './app.component';

import { HomeComponent}  from './Components/dashboard/home.component';
import { DashboardLayoutComponent}  from './Components/dashboard/dashboardlayout.component';

import {BusinessUnitComponent} from './Components/BusinessUnit/business.unit';
import {DeliveryunitComponent} from './Components/DeliveryUnit/delivery.unit';


import {SeedDataComponent} from './Components/SeedData/seed.data';

import {ProfileComponent} from './Components/TeamMember/Profile';

import {TeamMemberComponent} from './Components/TeamMemberManagement/TeamMember';

import {RolesComponent} from './Components/Roles/Roles';

import { PermissionsComponent } from './Components/Permissions/Permissions';

import { LoginComponent } from './Components/login/index';

import {AlertService, AuthenticationService, UserService, SeedDataService, ProfileDataService} from './Services/index';

import {AuthGuard} from './Shared/AuthGuards/auth.guard';
import { UserCreationComponent } from './Components/UserManagement/UserCreation';

import { HRBPDetailsComponent } from './Components/HRBusinessPartner/HRBPDetails.component';

//import {AuthGuard} from './AuthGuards/index';

import {AppRoutingModule} from './app-routing.module';
import {Configuration} from './Shared/Constants/index';
import { ForgotpasswordComponent } from './Components/login/forgotpassword.component';
import { PageNotFoundComponent } from './Shared/PageNotFound/page-not-found.component';
import {InputTextModule, TreeModule, SelectButtonModule, DataTableModule, SharedModule, ButtonModule, DialogModule, MessagesModule, DropdownModule, CalendarModule, Message, GrowlModule, PanelModule, ConfirmDialogModule, ConfirmationService, CheckboxModule, FileUploadModule, MultiSelectModule, BlockUIModule, DataGridModule} from 'primeng/primeng';
import {UserDetailsComponent} from './Components/UserDetails/UserDetails';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { HRBPDataService } from './Services/hrbp.service';

import { TeamMemberDirectoryService } from './Services/team-member-directory.service';
import { TeamMemberDirectoryComponent } from './Components/team-member-directory/team-member-directory.component';

import { EditKeyTrackerComponent } from './Components/edit-key-tracker/edit-key-tracker.component';
import {EditKeyTrackerService} from './Services/edit-key-tracker.service';
import { LoginviatranscendComponent } from './loginviatranscend/loginviatranscend.component';
import { OrgChartComponent } from './Components/org-chart/org-chart.component'
import { TeamHierarchyComponent } from './Components/TeamHierarchy/TeamHierarchy';
import { PriorRelevantExperienceComponent } from './Components/prior-relevant-experience/prior-relevant-experience.component'
import { PoliciesComponent } from './Components/Policies/policies.component';
import { PolicyViewerComponent } from './Components/PolicyViewer/policy-viewer.component';
import { PolicyService } from './Services/policy.service';

// used to create fake backend
//import { fakeBackendProvider } from './_helpers/index';
//import { MockBackend, MockConnection } from '@angular/http/testing';
export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    return new AuthHttp( new AuthConfig({noClientCheck:true}), http, options);
  }

@NgModule({

    imports: [
        HttpModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        InputTextModule,
        TreeModule,
        SelectButtonModule,
        DataTableModule,
        SharedModule,
        ButtonModule,
        DialogModule,
        MessagesModule,
        CalendarModule,
		GrowlModule,
        ReactiveFormsModule,
        PanelModule,
        ConfirmDialogModule,
        DropdownModule,
        CheckboxModule,
        AppRoutingModule,
        FileUploadModule,
        MultiSelectModule,
        BlockUIModule,
        DataGridModule
        
    ],

    declarations: [
        AppComponent,
        LoginComponent,
        DashboardLayoutComponent,
        HomeComponent,
        SeedDataComponent,               
        BusinessUnitComponent,
        ProfileComponent,
        TeamMemberComponent,
        UserCreationComponent,
        RolesComponent,
        PermissionsComponent,
        PageNotFoundComponent,
        ForgotpasswordComponent,
        DeliveryunitComponent,
        UserDetailsComponent,
        HRBPDetailsComponent,
        TeamMemberDirectoryComponent,
        EditKeyTrackerComponent,
        LoginviatranscendComponent,
        OrgChartComponent,
        TeamHierarchyComponent,
        PriorRelevantExperienceComponent,
        PoliciesComponent,
        PolicyViewerComponent
    
        
        
        
    ],
    providers: [
        AuthGuard,
        Configuration,
        TeamMemberDirectoryService,
        // AUTH_PROVIDERS,
        //AlertService,
        AuthenticationService,
        UserService,
        SeedDataService,
        ProfileDataService,
        Configuration,
        ConfirmationService  ,
        HRBPDataService,
        EditKeyTrackerService,
        PolicyService,
        // AuthHttp,
        // AuthConfig,
        // providers used to create fake backend
        // fakeBackendProvider,
        // MockBackend,
        // BaseRequestOptions
        // { provide: APP_BASE_HREF, useValue: '/' }
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [ Http, RequestOptions ]
        }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    bootstrap: [AppComponent]
})

export class AppModule { }




// WEBPACK FOOTER //
// ./src/app/app.module.ts